import { render, staticRenderFns } from "./Schedulatore.vue?vue&type=template&id=5c330756&scoped=true&"
import script from "./Schedulatore.vue?vue&type=script&lang=js&"
export * from "./Schedulatore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c330756",
  null
  
)

export default component.exports